module.exports = __webpack_public_path__ + "static/media/nona-small.31f1b0c8.svg";